import "core-js/modules/es6.regexp.replace";
import * as React from 'react';
import { mapColorLabelToHex } from '@origin-digital/helper';
import styled from 'styled-components';
import * as PropTypes from 'prop-types';
var iconPropTypes = {
  accessibilityLabel: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  'data-id': PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var iconDefaultTypes = {
  accessibilityLabel: '',
  size: 24,
  color: 'lightOrange',
  disabled: false
};
export var withIcon = function withIcon(iconSkin, iconName) {
  var displayName = "".concat(iconName, "Icon");

  var component = function component(props) {
    var accessibilityLabel = props.accessibilityLabel,
        color = props.color,
        size = props.size,
        disabled = props.disabled;
    var ariaHidden = accessibilityLabel === '' ? true : null;
    var SVGIcon = styled(iconSkin).withConfig({
      displayName: "Iconhoc__SVGIcon",
      componentId: "sc-1rpjt0u-0"
    })(["", " stroke-width:0;vertical-align:middle;"], disabled && 'opacity: 0.4;'); // TODO: remove this and publish package as a breaking change

    var dataIDDisplayName = "".concat(iconName[0].toLowerCase()).concat(iconName.substr(1));
    var generatedDataId = "".concat(color, "-").concat(dataIDDisplayName) + (accessibilityLabel ? "-".concat(accessibilityLabel.replace(' ', '-')) : '');
    return React.createElement(SVGIcon, {
      height: size,
      width: size,
      fill: "currentColor",
      color: mapColorLabelToHex(color),
      viewBox: "0 0 24 24",
      "aria-hidden": ariaHidden,
      "aria-label": accessibilityLabel,
      role: "img",
      className: props.className,
      "data-id": props['data-id'] || generatedDataId
    }, React.createElement("title", null, accessibilityLabel));
  };

  component.displayName = displayName;
  component.propTypes = iconPropTypes;
  component.defaultProps = iconDefaultTypes;
  return component;
};